import React from 'react';
import './PhotoGrid.css';

export default function PhotoGrid({ photos }) {
  return (
    <div className="photo-grid">
      {photos.map((photo) => (
        <div className="photo-grid-item" key={photo.id}>
          <img
            src={photo.src}
            alt={photo.alt}
            className="photo-grid-img"
            loading="lazy"
          />
          <div className="photo-grid-overlay">
            <span className="photo-grid-caption">{photo.caption}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
